import * as Yup from "yup";

export const validationSchema = [
  Yup.object().shape({
    Diagnoses: Yup.object().shape({
      DiagnosisID: Yup.string().trim().required("Required"),
      DoctorNotes: Yup.string()
        .trim()
        .matches(/^[\s\S]+$/, "Incorrect format")
        .min(0, "Cannot be empty")
        .max(100, "Must be 100 characters or less"),
    }),
    PrescriptionImage: Yup.string().trim(),
  }),
  Yup.object().shape({
    PrescribedEquipments: Yup.array().of(
      Yup.object().shape({
        Code: Yup.string().trim().required("Required"),
        Duration: Yup.number().required("Required"),
        Notes: Yup.string()
          .trim()
          .matches(/^[a-zA-Z0-9.\s]+$/, "Incorrect format")
          .min(0, "Cannot be empty")
          .max(100, "Must be 100 characters or less").required("Required"),
      })
    ),
  }),
  Yup.object().shape({
    PrescribedMedications: Yup.array().of(
      Yup.object().shape({
        Code: Yup.string().trim().required("Required"),
        Duration: Yup.number().required("Required"),
        Dose: Yup.string()
          .trim()
          .matches(/^[a-zA-Z0-9\s]+$/, "Incorrect format")
          .min(0, "Cannot be empty")
          .max(100, "Must be 100 characters or less").required("Required"),
      })
    ),
  }),
];
